const Banners1 = [
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/32655c2ae11bea21.jpg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/64f91be1237c8713.jpg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/a20cec49769ebfc5.jpg?q=50",
  },
];

const BannerCards = [
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/678cb440ca33d834.jpeg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/f5bdfa842ab79809.jpeg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/fd0138630c32d637.jpeg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/b3c8bf0011bb5232.jpeg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/eb98844d877d4fd0.jpeg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/d56ef338fcf1301b.jpeg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/ff25b2710f299d8d.jpeg?q=50",
  },
];
const underPrice = [
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/355/355/image/7efd35cdc8267684.jpg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/355/355/image/28f9586b304b6a00.jpg?q=50",
  },

  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/355/355/image/4fa0aefa270ae6fb.jpg?q=50",
  },
  //   {
  //     image:
  //       "https://rukminim1.flixcart.com/fk-p-flap/355/355/image/ef78f3350e144c2a.jpg?q=50",
  //   },
];

const pairs1 = [
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/f1fb234bda498674.jpeg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/45751a895efd7e82.jpg?q=50",
  },

  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/7864b554c3872f6a.jpg?q=50",
  },
];

const pairs2 = [
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/e76f677cc78ff541.jpeg?q=50",
  },

  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/35bb848cf754df8e.jpg?q=50",
  },
  {
    image:
      "https://rukminim1.flixcart.com/fk-p-flap/480/480/image/00d2e33cb2ec651d.jpeg?q=50",
  },
];

export { Banners1, BannerCards, underPrice, pairs1, pairs2 };
